import html from "./single_action_card.html";

export default {
    templateUrl: html,
    bindings: {
        i18n: "<",
        tutorialUrl: "<",
        icon: "@",
        onClick: "&",
    },
    controller: function SingleActionCardCtrl() {
        /////////////////////
        //
        //      Direct variables
        //
        /////////////////////

        var vm = this;

        /////////////////////
        //
        //      View model properties
        //
        /////////////////////

        vm.handleClick = handleClick;

        /////////////////////
        //
        //      Lifecycle Hooks
        //          docu: https://toddmotto.com/angular-1-5-lifecycle-hooks
        //
        /////////////////////

        /////////////////////
        //
        //      IMPL
        //
        /////////////////////

        function handleClick($event) {
            $event.stopPropagation();

            vm.onClick({
                $event: $event,
            });
        }
    },
};
